import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Expandable } from 'UI';
import './Styles.scss';

var SelectedCoreContent = /*#__PURE__*/function (_Component) {
  _inherits(SelectedCoreContent, _Component);

  var _super = _createSuper(SelectedCoreContent);

  function SelectedCoreContent() {
    var _this;

    _classCallCheck(this, SelectedCoreContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "getContents", function () {
      var _this$props = _this.props,
          associatedCoreContent = _this$props.associatedCoreContent,
          assessmentBlocks = _this$props.assessmentBlocks;
      var coreContents = [];

      if (associatedCoreContent != null) {
        associatedCoreContent.map(function (reference) {
          if (reference == null || reference.coreContents == null) {
            return false;
          }

          reference.coreContents.map(function (coreContent) {
            var findCourse = null;
            assessmentBlocks.forEach(function (block) {
              block.resources.forEach(function (resource) {
                if (resource.referenceType == 'matrix') {
                  var detail = resource.value.details.find(function (detail) {
                    return detail.id == coreContent.courseDetailsId;
                  });

                  if (detail != null) {
                    findCourse = resource.value;
                  }
                }
              });
            });
            var courseTitle = "";
            var courseId = "";

            if (findCourse != null) {
              courseTitle = findCourse.title;
              courseId = findCourse.id;
            }

            coreContents.push(_objectSpread(_objectSpread({}, coreContent), {}, {
              courseTitle: courseTitle,
              courseId: courseId
            }));
          });
        });
      } else {
        if (_this.props.coreContents != null && _this.props.coreContents.length > 0) {
          coreContents = _this.props.coreContents[0].coreContents;
        }
      }

      return coreContents;
    });

    return _this;
  }

  _createClass(SelectedCoreContent, [{
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      var coreContents = this.getContents();

      if (coreContents == null || coreContents.length == 0) {
        return null;
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "core-content selected"
      }, /*#__PURE__*/React.createElement("h3", {
        style: {
          fontWeight: 500
        }
      }, this.props.translate('central-content')), /*#__PURE__*/React.createElement(Expandable, {
        title: translate('plan-contains-core-content-title'),
        whiteBackground: true,
        key: 'core-content-container'
      }, coreContents.map(function (coreContent, i) {
        return /*#__PURE__*/React.createElement("div", {
          style: i > 0 ? {
            paddingTop: "2rem"
          } : {},
          key: coreContent.id
        }, coreContent.courseTitle != null && coreContent.courseTitle != "" ? /*#__PURE__*/React.createElement("h2", {
          style: {
            textDecorationLine: "underline"
          }
        }, coreContent.courseTitle) : null, coreContent.aspects.length > 0 ? /*#__PURE__*/React.createElement("div", {
          style: {
            paddingLeft: "2rem"
          },
          className: "core-content-row"
        }, coreContent.aspects.map(function (aspect) {
          return /*#__PURE__*/React.createElement("div", {
            className: "content-row",
            key: 'core-content-row-' + aspect.id
          }, /*#__PURE__*/React.createElement("h4", null, aspect.title != null ? aspect.title : ""), /*#__PURE__*/React.createElement("ul", null, aspect.aspectRows.map(function (row) {
            return /*#__PURE__*/React.createElement("li", {
              key: 'aspect-row-' + row.id
            }, row.text);
          })));
        })) : null);
      })));
    }
  }]);

  return SelectedCoreContent;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    activeSection: state.sections.activeSection
  };
}

export default connect(mapStateToProps)(SelectedCoreContent);